import { FacetFilterMenu } from '@/components/FacetFilterMenu'
import type { FacetGroup } from '@/components/FacetFilterMenu'
import { SUBSCRIPTION_FILTER_LABELS, SUBSCRIPTION_FILTER_VALUES } from '@/lib/subscription'
import { VALIDATION_STATUS_LABELS, VALIDATION_STATUS_VALUES } from '@/lib/validation'
import {
  AGENT_GROUP_LABEL,
  AGENT_ID_PARAM,
  ENABLE_POSTNORD_PARAM,
  SHIPMENT_AUTOMATION_GROUP_LABEL,
  SHIPMENT_AUTOMATION_OPTIONS,
  SUBSCRIPTION_GROUP_LABEL,
  SUBSCRIPTION_STATUS_PARAM,
  VALIDATION_GROUP_LABEL,
  VALIDATION_STATUS_PARAM,
  countMenuFacets,
  formatAgentName,
  toggleAgentId,
  toggleShipmentAutomation,
  toggleSubscriptionStatus,
  toggleValidationStatus
} from '@/lib/customerFilters'
import type { CustomerFacetFilters } from '@/lib/customerFilters'
import type { CustomerAgent } from '@/api/types'

interface CustomerFilterMenuProps {
  filters: CustomerFacetFilters
  agents: CustomerAgent[]
  onChange: (next: CustomerFacetFilters) => void
}

export function CustomerFilterMenu({ filters, agents, onChange }: CustomerFilterMenuProps): React.ReactElement {
  const groups: FacetGroup[] = [
    {
      key: ENABLE_POSTNORD_PARAM,
      label: SHIPMENT_AUTOMATION_GROUP_LABEL,
      options: SHIPMENT_AUTOMATION_OPTIONS.map((option) => ({
        key: option.value,
        label: option.label,
        isChecked: filters.enablePostnord === option.value,
        onToggle: () => onChange(toggleShipmentAutomation(filters, option.value))
      }))
    },
    {
      key: SUBSCRIPTION_STATUS_PARAM,
      label: SUBSCRIPTION_GROUP_LABEL,
      options: SUBSCRIPTION_FILTER_VALUES.map((status) => ({
        key: status,
        label: SUBSCRIPTION_FILTER_LABELS[status],
        isChecked: filters.subscriptionStatuses.includes(status),
        onToggle: () => onChange(toggleSubscriptionStatus(filters, status))
      }))
    },
    {
      key: VALIDATION_STATUS_PARAM,
      label: VALIDATION_GROUP_LABEL,
      options: VALIDATION_STATUS_VALUES.map((status) => ({
        key: status,
        label: VALIDATION_STATUS_LABELS[status],
        isChecked: filters.validationStatuses.includes(status),
        onToggle: () => onChange(toggleValidationStatus(filters, status))
      }))
    },
    {
      key: AGENT_ID_PARAM,
      label: AGENT_GROUP_LABEL,
      emptyLabel: 'Inga säljare att välja',
      options: agents.map((agent) => ({
        key: String(agent.id),
        label: formatAgentName(agent),
        isChecked: filters.agentIds.includes(agent.id),
        onToggle: () => onChange(toggleAgentId(filters, agent.id))
      }))
    }
  ]

  return (
    <FacetFilterMenu
      groups={groups}
      activeCount={countMenuFacets(filters)}
    />
  )
}
